<template>
  <div class="page-fixed">
    <van-list
      v-model="loading"
      :finished="finished"
      :loading-text="$t('加载中...')"
      :finished-text="finishedText"
      v-if="!noDataBool"
    >
      <section
        class="section"
        v-for="(item, index) in listData"
        :key="index"
        @click="jumpDetail(item)"
      >
        <div v-lazy:background-image="item.appHeader">
          <h3>
            <img src="@/assets/img-m/icon-new.png" alt="" />{{ item.title }}
          </h3>
          <p>{{ item.pubTime | dataFilter }}</p>
        </div>
      </section>
    </van-list>
    <van-empty
      v-else
      class="custom-image img-list-box"
      :image="require('@/assets/img-m/no-list.png')"
      :description="$t('暂无数据')"
    />
  </div>
</template>

<script>
import getTranslation from '@/locale/getTranslation'
import { getDescribeContentListApi } from '@/api/news'
export default {
  data() {
    return {
      loading: false,
      finished: false,
      noDataBool: false,
      finishedText: '',
      listData: [
        {
          title:
            '待会上课活动开始的但是看到所谓把不可描述是大会开始的开始的的时代开始打瞌睡',
          appHeader:
            'https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1593516694&di=d71580f5b5dc3aa8bb56b530c58ad692&src=http://cdn.duitang.com/uploads/item/201305/12/20130512095153_WSu5Q.jpeg',
          pubTime: '1596124800000'
        },
        {
          title:
            '待会上课活动开始的但是看到所谓把不可描述是谓把不可描述是大会开始的开始的的时代开谓把不可描述是大会开始的开始的的时代开',
          appHeader:
            'https://t9.baidu.com/it/u=4232638211,752460314&fm=193&app=53&size=w414&n=0&g=0n&f=jpeg?sec=1596083091&t=b2bd40645d61c8559a90d8e61153d607',
          pubTime: '1596124800000'
        },
        {
          title:
            '待会上课活动开始的但是看到所谓把不可描述是待会上课活动开始的但是看到所谓把不可描述是待会上课活动开始的但是看到所谓把不可描述是',
          appHeader:
            'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1593501221092&di=e0211473d9c646d7aa65b45809f02eec&imgtype=0&src=http%3A%2F%2Ft9.baidu.com%2Fit%2Fu%3D4024223166%2C417422453%26fm%3D193',
          pubTime: '1596124800000'
        }
      ],
      pageNum: 1
    }
  },
  methods: {
    onLoad() {
      let pageNum = this.pageNum
      getDescribeContentListApi({
        classification: 'activity',
        title: '',
        pageNum,
        pageSize: '10'
      }).then(res => {
        //判断暂无数据
        if (res.result.data.total == 0) {
          this.noDataBool = true
        } else {
          //添加数据
          let list = res.result.data.list
          this.listData = this.listData.concat(list)
          this.loading = false
          this.pageNum = pageNum += 1 //设置页码
          // 数据全部加载完成
          if (this.pageNum > res.result.data.pages) {
            this.finished = true
          }
          //数据少于10条隐藏“已经到底了”文案
          if (res.result.data.total <= 10) {
            this.finishedText = ''
          } else {
            this.finishedText = getTranslation('已经到底了~')
          }
        }
      })
    },
    jumpDetail() {
      this.$router.push({
        name: 'mobile_picture_detail',
        query: {
          id: ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.section {
  width: 6.9rem;
  height: 4.6rem;
  margin: 0.3rem auto;
  background: #fcfafa url('../../../assets/img-m/set-img.png') no-repeat center;
  background-size: 1.8rem;
  border-radius: 0.1rem;
  overflow: hidden;
  > div {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    // background-size: 100% auto;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    color: #ffffff;
    padding: 0 0.2rem;
    overflow: hidden;
    h3 {
      @include ellipsisMultiline($number: 2);
      font-size: 0.32rem;
      line-height: 0.44rem;
      padding-top: 3.1rem;
      flex: 1;
      -webkit-flex: 1;
      img {
        width: 0.7rem;
        margin-right: 0.08rem;
        vertical-align: middle;
      }
    }
    p {
      height: 0.7rem;
      padding-top: 0.16rem;
      font-size: 0.24rem;
    }
  }
}
</style>
